import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

// Service Worker登録
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then((registration) => {
        console.log('Service Worker registered:', registration.scope);
        
        // 定期的なバックグラウンド同期（サポートされている場合）
        if ('sync' in registration) {
          registration.sync.register('check-daily-input').catch(() => {
            // Background sync not supported, silently ignore
          });
        }
      })
      .catch(() => {
        // Service Worker not supported in this environment, silently ignore
      });
  });
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)